import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {
    FL_IMAGE,
    FL_TITLE
} from "../../../../components/i18n/formLabels";
import {
    PH_IMAGE,
    PH_TITLE
} from "../../../../components/i18n/placeHolders";
import {LangController} from "../../../../components/tabs/langController";


const HomeCategorySectionLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            title: '',
            image: '',
        }) )

        setLangChilds(items);
    }


    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md={'12'}>
                <FormGroup>
                    <Label>{FL_TITLE}</Label>
                    <Input
                        type="text"
                        name="title"
                        placeholder={PH_TITLE}
                        value= { child.title }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            {
                props.isAdmin &&
                <Col md={'12'}>
                    <FormGroup>
                        <Label>{FL_IMAGE}</Label>
                        <Input
                            type="text"
                            name="image"
                            placeholder={PH_IMAGE}
                            value= { child.image }
                            onChange={e => onInputChange(e, child.lang)}
                            disabled={disableInputs}
                        />
                    </FormGroup>
                </Col>
            }
        </Row>
    </>

    return <LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
        orientation={'horizontal'}
    />
}

export default HomeCategorySectionLangs